import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { DataSource } from "@/types/common.types";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export type StyleIdInfo = {
  styleId: string;
  dataSource: DataSource;
};

export type JobStyleScheduleVariables = {
  uploadSessionId: number;
  jobName: string;
  startTime: string;
  endTime: string;
  frequency: number;
  styleIds: StyleIdInfo[];
  tenantIds: string[];
};

type JobStyleScheduleResponse = void;

const scheduleJobStyle = async (
  variables: JobStyleScheduleVariables
): Promise<JobStyleScheduleResponse> => {
  return apiClient
    .post(ENDPOINTS.SCHEDULE_JOB_STYLES, {
      json: variables,
    })
    .json<JobStyleScheduleResponse>();
};

export const useJobStyleScheduleMutation = (
  options?: UseMutationOptions<
    JobStyleScheduleResponse,
    Error,
    JobStyleScheduleVariables
  >
) => {
  return useMutation({
    mutationFn: scheduleJobStyle,
    ...options,
  });
};
